import {getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store, ComputedSignal} from '@gongxigames/framework/core/fragments/store/Store';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {Easing} from '@gongxigames/framework/core/fragments/tween/Easing';
import {Container} from 'pixi.js';
import {PopupProps} from './Popup';
import {PopupFaderProps} from './PopupFader';

export function createPopupPaddingComputed(props: PopupProps): ComputedSignal<ResponsiveConf> {
    return Store.computed(() => {
        const padding = getProp(props.padding, ['180px', '48px', '72px', '48px']);
        // const padding = getProp(props.padding, [HEADER_HEIGHT + 24*3, '48px', '72px', '48px']);
        const responsive: ResponsiveConf = {
            box: {width: '100%', height: '100%'},
            padding,
        };

        return responsive;
    });
}

const ANIMATION_DURATION = 16 * 6;

export function createFaderTween(props: PopupFaderProps, fader: Container): () => void {
    return Store.effect(() => {
        const show = getProp(props.show);
        const alpha = show ? 1 : 0;
        const initialAlpha = show ? 0 : 1;

        fader.alpha = initialAlpha;

        slotStore.updateManager.value!
            .addTween(fader)
            .to({alpha}, ANIMATION_DURATION)
            .start();
    });
}

export function createPopupTween(props: PopupProps, popup: Container): () => void {
    return Store.effect(() => {
        const show = getProp(props.show);
        const alpha = show ? 1 : 0;
        const initialAlpha = show ? 0 : 1;
        const initialY = show ? 40 : 0;
        const scale = show ? 1 : 0.975;
        const delay = show ? ANIMATION_DURATION : 0;

        popup.alpha = initialAlpha;
        popup.y = initialY;

        slotStore.updateManager.value!
            .addTween(popup)
            .delay(delay)
            .easing(Easing.Quadratic.InOut)
            .to({alpha, y: 0}, ANIMATION_DURATION)
            .start()
            .onComplete(() => {
                popup.visible = show;
            });

        slotStore.updateManager.value!
            .addTween(popup.scale)
            .delay(delay)
            .easing(Easing.Quadratic.InOut)
            .to({x: scale, y: scale}, ANIMATION_DURATION)
            .start();
    });
}

